import {useEffect, useMemo, useState} from "react";
import {
  ArrayInput,
  AutocompleteArrayInput,
  AutocompleteInput, BooleanInput, FormTab, NumberField,
  ReferenceInput, SimpleForm,
  SimpleFormIterator, TabbedForm,
  TextInput, useFormContext
} from "react-admin";
import dataProvider from "../../../providers/data-provider";
import {useForm} from "react-final-form";
import {Alert} from "@material-ui/lab";

export function QuizAssessmentQuestionForm(props) {
  const [tags, setTags] = useState([]);

  useEffect(() => {
    dataProvider.get('quiz-assessment-question', 'tags').then(res =>
      setTags(res.data.map(tag => ({ id: tag, name: tag })))
    );
  }, []);

  const disableEdition = useMemo(() => props.record.id && !props.record.ownerId, [props.record]);

  return (
    <TabbedForm
      redirect={'list'}
      {...props}
    >
      <FormTab label={'Dados Básicos'}>
        {
            disableEdition && (
                <Alert severity={'info'} fullWidth={true}>
                  Não é possível editar uma questão do sistema !
                </Alert>
            )
        }
        {
          props.record?.code ? <NumberField source={'code'} label={'Código da Questão'} /> : null
        }
        <ReferenceInput
            disabled={disableEdition}
            reference="themes"
            source="themeId"
            label="Área do direito"
            sort={{ field: 'name', order: 'ASC' }}
            fullWidth
        >
          <AutocompleteInput source="name" fullWidth />
        </ReferenceInput>
        <TextInput
            disabled={disableEdition}
            source="question"
            label="Enunciado"
            multiline
            minRows={5}
            fullWidth
            required
        />
        <AutocompleteArrayInput
          source="tags"
          label={'Tags'}
          choices={tags}
          disabled={disableEdition}
          fullWidth
          onCreate={(newTag) => {
            const _newTag = { id: newTag, name: newTag };
            setTags(prev => [...prev, _newTag]);
            return _newTag;
          }}
          createLabel={'Cadastrar nova tag:'}
        />
        {/*<BooleanInput source={'shared'} label={'Deseja compartilhar questão com demais usuários'}  style={{width: '100%'}} />*/}
      </FormTab>
      <FormTab label={'Alternativas'}>
        <ArrayInput
            source='options'
            label="Opções"
            fullWidth
            disabled={disableEdition}
            validate={(value) => {
              if (value?.length < 2) {
                return { message: 'Informe pelo menos 3 opções' }
              }
              const isCorrectLength = value?.filter(w => w?.isCorrect).length;
              if (isCorrectLength < 1) {
                return {
                  message: 'É obrigatório termos uma opção correta !'
                }
              } else if(isCorrectLength > 1) {
                return {
                  message: 'Apenas uma opção deve ser marcada como correta!'
                }
              }
            }}
          >
          <SimpleFormIterator>
            <TextInput
                disabled={disableEdition}
                source="optionText"
                label="Texto"
                multiline
                minRows={1}
                fullWidth
                required
            />
            <BooleanInput
                disabled={disableEdition}
                source='isCorrect'
                label="Correta ?"
                defaultValue={false}
                fullWidth
            />
            <Validation />
          </SimpleFormIterator>
        </ArrayInput>

      </FormTab>
      <FormTab label={'Feedback da Questão'}>
        <TextInput
            disabled={disableEdition}
            source="comments"
            label="Comentários"
            multiline
            minRows={2}
            fullWidth
        />
      </FormTab>

    </TabbedForm>
  )
}

function Validation(props) {
  const form = useForm();

  return null;
}